import React from 'react';
import { CircleCheckIcon, CreditCardIcon, FileDownIcon, ShieldCheckIcon } from 'lucide-react';
import { heroTicks, product } from '../data/landing';
import { CtaButton } from './CtaButton';
const trust = [{
  icon: FileDownIcon,
  label: 'PDF download'
}, {
  icon: CreditCardIcon,
  label: 'One-time payment'
}, {
  icon: ShieldCheckIcon,
  label: '10-day guarantee'
}];
export function Hero() {
  return <section className="bg-ivory text-ink" data-id="element-94" data-mp="129qrndlnhbk6">
      <div className="mx-auto grid max-w-[1180px] grid-cols-1 items-center gap-x-12 gap-y-5 px-5 pb-8 pt-6 text-center md:grid-cols-[1.15fr_1fr] md:gap-y-8 md:px-8 md:py-20 md:text-left" data-id="element-95" data-mp="127edzcmxdncx">
        <div className="md:col-start-1 md:row-start-1 md:self-end" data-id="element-96" data-mp="s9ghk1uwwk98">
          <span className="inline-flex items-center gap-2 rounded-full border border-teal/30 bg-teal/10 px-4 py-1.5 text-[10px] font-bold uppercase tracking-[1.8px] text-teal-dark sm:text-xs md:py-2" data-id="element-97" data-mp="nb6llp1d5fmk">
            <span className="h-1.5 w-1.5 rounded-full bg-teal" aria-hidden="true" data-id="element-98" data-mp="381e0zavri1sz" />
            For youth pastors & volunteer leaders
          </span>
          <h1 className="mt-4 font-display text-[clamp(34px,9.6vw,80px)] font-extrabold uppercase leading-[0.92] text-navy md:mt-6 md:text-[clamp(44px,6.2vw,80px)]" data-id="element-99" data-mp="3j6o8rb5sq6lv">
            Run your next 12 youth meetings{' '}
            <span className="text-teal" data-id="element-100" data-mp="3e9625rf943h1">without planning from scratch.</span>
          </h1>
        </div>

        <div className="flex justify-center md:col-start-2 md:row-span-2 md:row-start-1" data-id="element-101" data-mp="30hhpnn13bczj">
          <img src={product.mockup} alt="Youth Ministry Ready box set: Identity & Faith volume with the 5 bonus books" width={1024} height={1536} className="h-[min(40svh,360px)] w-auto rounded-2xl shadow-[0_24px_50px_rgba(20,33,61,0.22)] md:h-auto md:w-full md:max-w-[460px]" data-id="element-102" data-mp="358hmksa7lv21" />
        </div>

        <div className="md:col-start-1 md:row-start-2 md:self-start" data-id="element-103" data-mp="2hjyn92950sm3">
          <p className="hidden max-w-[580px] text-lg text-muted md:block" data-id="element-104" data-mp="2ljpef72ktar5">
            YOUTH MINISTRY READY™ is a 12-meeting Bible-based series for ages 12–18: timed agendas, games, leader
            scripts, discussion questions, and printable student handouts. Open a meeting and see exactly what to do.
          </p>
          <ul className="mt-6 hidden flex-wrap gap-x-5 gap-y-2.5 md:flex" data-id="element-105" data-mp="ichxv1qe0c30">
            {heroTicks.map(tick => <li key={tick} className="flex items-center gap-1.5 text-sm font-semibold text-navy" data-id="element-106" data-mp="db2f5gbomhns">
                <CircleCheckIcon className="h-4 w-4 text-teal" aria-hidden="true" data-id="element-107" data-mp="1ayjhtfeu9i6s" />
                {tick}
              </li>)}
          </ul>
          <CtaButton href="#offer-details" className="w-full sm:w-auto md:mt-8" data-id="element-108" data-mp="111om149y9vw7">
            {product.ctaLabel}
          </CtaButton>
          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1.5 text-[13px] text-muted md:mt-6 md:justify-start md:gap-x-5" data-id="element-109" data-mp="x0ut1whnhqwg">
            {trust.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-1.5" data-id="element-110" data-mp="3hq26kygu48ad">
                <Icon className="h-4 w-4 text-teal" aria-hidden="true" data-id="element-111" data-mp="1xaceczu3ndrn" />
                {label}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}